import {Observable} from "rxjs";

export abstract class CreateShareProductsLinkService {
    abstract execute(productCodes: string[]): Observable<string>;
}